/**
 * Graphical requests API — the account's API keys and webhook
 * (/compuzz/rest/v2/api-keys). The API itself (/compuzz/rest/public/v1) is
 * called by the customers' systems with a key, never from the dashboard.
 */
define('entities/api_keys',[
  'app',
  'jquery',
  'settings'
], function (App, $, Settings) {
  'use strict';

  var API = {
    keysUrl: function () { return Settings.url('compuzz2', 'v2/api-keys'); },
    keyUrl: function (secId) { return Settings.url('compuzz2', 'v2/api-keys/' + encodeURIComponent(secId)); },
    webhookUrl: function () { return Settings.url('compuzz2', 'v2/api-keys/webhook'); },
    pingUrl: function () { return Settings.url('compuzz2', 'v2/api-keys/webhook/ping'); }
  };

  function send(type, url, body) {
    var defer = $.Deferred();
    $.ajax({
      type: type,
      url: url,
      contentType: 'application/json',
      data: body === undefined ? undefined : JSON.stringify(body),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  }

  // Base of the public API on this server, e.g. https://admin.compuzz.com/compuzz/rest/public/v1
  App.reqres.setHandler('apiKeys:api-base-url', function () {
    return Settings.url('base', 'compuzz/rest/public/v1', null, true).split('?')[0];
  });

  App.reqres.setHandler('apiKeys:list', function () {
    return send('GET', API.keysUrl());
  });

  // The answer carries the plain key ({key}) this once.
  App.reqres.setHandler('apiKeys:create', function (name) {
    return send('POST', API.keysUrl(), {name: name});
  });

  App.reqres.setHandler('apiKeys:revoke', function (secId) {
    return send('DELETE', API.keyUrl(secId));
  });

  // Resolves with null when no webhook is set (204).
  App.reqres.setHandler('apiKeys:webhook:get', function () {
    return send('GET', API.webhookUrl()).then(function (data) { return data || null; });
  });

  App.reqres.setHandler('apiKeys:webhook:set', function (url, rotateSecret) {
    return send('PUT', API.webhookUrl(), {url: url, rotateSecret: !!rotateSecret});
  });

  App.reqres.setHandler('apiKeys:webhook:delete', function () {
    return send('DELETE', API.webhookUrl());
  });

  App.reqres.setHandler('apiKeys:webhook:ping', function () {
    return send('POST', API.pingUrl());
  });
});

